import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {fetchData, isEmpty} from "@/utils/global-functions";
import {REQ_TYPES} from "@/constants/general-constants";
import {setLayout} from "@/redux/slices/layout-slice";
import {toast} from "react-toastify";
import Cookies from "js-cookie";
import {clearWalletInfo, login, logout, setWalletInfo} from "@/redux/slices/user-slice";

export default function MainLayout() {
    const layoutData = useSelector((state) => state.layout.data);
    const {isLoggedIn, walletInfo} = useSelector((state) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            if(Cookies.get(process.env.NEXT_PUBLIC_FREELANCER_TOK)) {
                dispatch(login());
            } else {
                dispatch(logout())
                dispatch(clearWalletInfo())
            }

            if (isEmpty(layoutData)) {
                const data = await fetchData('layout', REQ_TYPES.GET);

                if (!data.error) {
                    if (!isEmpty(data.data)) {
                        try {
                            dispatch(setLayout(data.data.data))
                        } catch (e) {
                            toast.error("خطا در بارگذاری اطلاعات لایه")
                        }
                    }
                }
            }
        })()
    }, []); // eslint-disable-line

    useEffect(() => {
        (async () => {
            if(isEmpty(walletInfo) && isLoggedIn) {
                const walletData = await fetchData("panel/wallet", REQ_TYPES.GET, {}, true);
                if(!walletData.error) {
                    dispatch(setWalletInfo(walletData.data.data.wallet))
                } else {
                    toast.error(<div><p>خطا در بارگذاری اطلاعات کیف پول!</p><p>فعلا نمی توانید با کیف پول خرید کنید</p></div>)
                }
            }
        })()
        // eslint-disable-next-line
    }, [isLoggedIn]);


    return <></>
}
